import React from "react";
import { PayForAllAvatars } from "../payForAllAvatars/PayForAllAvatars";
import { TCText } from "../TCText/TCText";
import { RadioButton } from "../radioButton/RadioButton";
import { observer } from "mobx-react-lite";
import {
  usePaymentStore,
  useSelectCircleStore,
} from "../../stores/StoreContext";

interface PayForAllProps {}

export const PayForAll: React.FC<PayForAllProps> = observer(() => {
  const selectedCircleStore = useSelectCircleStore();
  const paymentStore = usePaymentStore();

  return selectedCircleStore.adjustAndGetSelectedPlayersList().length > 1 ? (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 20,
        }}>
        <PayForAllAvatars
          avatar={selectedCircleStore
            .adjustAndGetSelectedPlayersList()
            .flatMap((p) => ({
              name: p.name,
              image: p.userImageUrl,
            }))}
        />
        <TCText
          style={{ fontWeight: 500, fontSize: 14, color: "black" }}
          value="Pay for all players"
        />
      </div>
      <RadioButton
        onChange={() => {
          paymentStore.setIsPayForAll(!paymentStore.getIsPayForAll());
        }}
        selected={paymentStore.getIsPayForAll()}
      />
    </div>
  ) : (
    <div style={{ height: 20 }} />
  );
});
